<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories/furniture-categories">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                {{ isNew ? 'Добавить' : 'Редактировать' }}
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility">
                    </div>
                    <div class="form">
                      <div class="fieldset">
                        <label class="fieldset-title">Цена, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('price')}">
                          <input type="number" v-model="price"
                                 v-validate="'required'" :class="{'input': true}" name="price">
                          <span v-show="errors.has('price')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Зар. плата, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('salary')}">
                          <input type="number" v-model="salary"
                                 v-validate="'required'" :class="{'input': true}" name="salary">
                          <span v-show="errors.has('salary')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Надбавка клиенту за проезд (ночной тариф), руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('clientSurcharge')}">
                          <input type="number" v-model="clientSurcharge"
                                 v-validate="'required'" :class="{'input': true}" name="clientSurcharge">
                          <span v-show="errors.has('clientSurcharge')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Надбавка рабочему за проезд (ночной тариф), руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('workerSurcharge')}">
                          <input type="number" v-model="workerSurcharge"
                                 v-validate="'required'" :class="{'input': true}" name="workerSurcharge">
                          <span v-show="errors.has('workerSurcharge')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Минимальная продолжительность, час.</label>
                        <fieldset :class="{'fieldset-error': errors.has('minDuration')}">
                          <input type="number" v-model="minDuration"
                                 v-validate="'required'" :class="{'input': true}" name="minDuration">
                          <span v-show="errors.has('minDuration')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="cashless-block">
                        <div class="fieldset">
                          <div class="title">Надбавка за безнал</div>
                        </div>
                        <div class="fieldset">
                          <label class="fieldset-title">Надбавка часовая, руб.</label>
                          <fieldset :class="{'fieldset-error': errors.has('priceSurchargeByCashless')}">
                            <input type="number" v-model="priceSurchargeByCashless"
                                   v-validate="'required'" :class="{'input': true}" name="priceSurchargeByCashless">
                            <span v-show="errors.has('priceSurchargeByCashless')" class="error-text">Заполните обязательное поле</span>
                          </fieldset>
                        </div>
                        <div class="fieldset">
                          <label class="fieldset-title">Надбавка клиенту за проезд (ночной тариф), руб.</label>
                          <fieldset :class="{'fieldset-error': errors.has('clientPriceSurchargeByCashless')}">
                            <input type="number" v-model="clientPriceSurchargeByCashless"
                                   v-validate="'required'" :class="{'input': true}"
                                   name="clientPriceSurchargeByCashless">
                            <span v-show="errors.has('clientPriceSurchargeByCashless')" class="error-text">Заполните обязательное поле</span>
                          </fieldset>
                        </div>
                      </div>
                      <div class="buttons">
                        <button type="button" class="save-button" @click="save">Сохранить</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import api from '@/api'
    import VeeValidate from 'vee-validate'

    export default {
  name: 'FurnitureCategory',
  components: {
    MenuDispatcher,
    HeaderDispatcher,
    VeeValidate
  },

  data () {
    return {
      id: null,
      isNew: false,
      furnitureCategory: {},
      newFurnitureCategory: {}
    }
  },

  computed: {
    name: {
      get () {
        return !this.isNew ? this.furnitureCategory.name : this.newFurnitureCategory.name
      },

      set (name) {
        !this.isNew ? this.furnitureCategory.name = name : this.newFurnitureCategory.name = name
      }
    },
    price: {
      get () {
        return !this.isNew ? this.furnitureCategory.price : this.newFurnitureCategory.price
      },

      set (price) {
        !this.isNew ? this.furnitureCategory.price = price : this.newFurnitureCategory.price = price
      }
    },
    clientSurcharge: {
      get () {
        return !this.isNew ? this.furnitureCategory.clientSurcharge : this.newFurnitureCategory.clientSurcharge
      },

      set (clientSurcharge) {
        !this.isNew ? this.furnitureCategory.clientSurcharge = clientSurcharge : this.newFurnitureCategory.clientSurcharge = clientSurcharge
      }
    },
    salary: {
      get () {
        return !this.isNew ? this.furnitureCategory.salary : this.newFurnitureCategory.salary
      },

      set (salary) {
        !this.isNew ? this.furnitureCategory.salary = salary : this.newFurnitureCategory.salary = salary
      }
    },
    workerSurcharge: {
      get () {
        return !this.isNew ? this.furnitureCategory.workerSurcharge : this.newFurnitureCategory.workerSurcharge
      },

      set (workerSurcharge) {
        !this.isNew ? this.furnitureCategory.workerSurcharge = workerSurcharge : this.newFurnitureCategory.workerSurcharge = workerSurcharge
      }
    },
    minDuration: {
      get () {
        return !this.isNew ? this.furnitureCategory.minDuration : this.newFurnitureCategory.minDuration
      },

      set (minDuration) {
        !this.isNew ? this.furnitureCategory.minDuration = minDuration : this.newFurnitureCategory.minDuration = minDuration
      }
    },

    priceSurchargeByCashless: {
      get () {
        return !this.isNew ? this.furnitureCategory.priceSurchargeByCashless : this.newFurnitureCategory.priceSurchargeByCashless
      },

      set (priceSurchargeByCashless) {
        !this.isNew ? this.furnitureCategory.priceSurchargeByCashless = priceSurchargeByCashless
          : this.newFurnitureCategory.priceSurchargeByCashless = priceSurchargeByCashless
      }
    },

    clientPriceSurchargeByCashless: {
      get () {
        return !this.isNew ? this.furnitureCategory.clientPriceSurchargeByCashless : this.newFurnitureCategory.clientPriceSurchargeByCashless
      },

      set (clientPriceSurchargeByCashless) {
        !this.isNew ? this.furnitureCategory.clientPriceSurchargeByCashless = clientPriceSurchargeByCashless
          : this.newFurnitureCategory.clientPriceSurchargeByCashless = clientPriceSurchargeByCashless
      }
    }
  },

  mounted () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')

    this.id = this.$route.params.id
    if (this.id == 'new') {
      this.isNew = true
      this.newFurnitureCategory = {
        name: 'Сборка мебели',
        price: null,
        salary: null,
        clientSurcharge: null,
        workerSurcharge: null,
        minDuration: null,
        priceSurchargeByCashless: null,
        clientPriceSurchargeByCashless: null
      }
    } else {
      api
        .getFurnitureCategoryById(this.id)
        .then(furnitureCategory => {
          if (furnitureCategory) {
            this.furnitureCategory = furnitureCategory
            this.isNew = false
          }
        })
    }
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('cabinet-page')
  },

  methods: {
    // remove() {
    //   this.furnitureCategory.removed = true;
    //   this.save();
    // },

    save () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.$store.getters.waitingApiRequestsCount != 0) { return }

          this.isNew
            ? api
              .createFurnitureCategory(this.newFurnitureCategory)
              .then(() => {
                this.$router.push('/directories/furniture-categories')
                alert('Сохранено')
              })
              .catch(err => alert(err))
            : api
              .updateFurnitureCategory(this.id, this.furnitureCategory)
              .then(() => {
                this.$router.push('/directories/furniture-categories')
                alert('Сохранено')
              })
              .catch(err => alert(err))
        }
      })
    }
  }
}
</script>
